import React from 'react'
import { component_tool } from '../../../tool';
let { WizModal } = component_tool;
import { WizJointExhibition } from '../../common'

//配置项
let componentName = 'organization'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "上级组织",
    name: "parentId",
    dataIndex: "parentId",
    dict: {
      wizReplaceData: "treeData",
      defalutType: []
    },
    formItem: {
      type: 'treeselect',
      allowClear: true,
      //onChange: this._orgnChange
    },
  },
  {
    title: '组织编码',
    name: 'links',
    formItem: {
      type: 'diy',
      links: 'parentId',
      diy: ({ linksValues }) => {
        let wizJointExhibitionProps = {
          type: 'org',
          data: linksValues
        }
        return <WizJointExhibition {...wizJointExhibitionProps} />
      }
    }
  },
  {
    title: "组织名称",
    name: "name",
    dataIndex: "name",
    formItem: {
      maxlength: 50,
      placeholder: '组织名称不能超过50个字符',
      rules: [
        {
          required: true,
          message: '请输入组织类型名称'
        },
        {
          pattern: /^[^\s]*$/,
          message: '组织类型名称录入信息不能包含空格'
        }
      ],
    },
    searchItem: {},
    tableItem: {
      width: 200
    }
  },
  {
    title: "组织编码",
    name: "code",
    dataIndex: "code",
    formItem: {
      maxlength: 50,
      placeholder: '组织编码不能超过50个字符',
      rules: [{
        required: true,
        message: '请输入组织编码',
      }]
    },
    searchItem: {},
    tableItem: {
      width: 200
    }
  },
  {
    title: "组织类型",
    name: "organizationNodeCategory",
    dataIndex: "organizationNodeCategory",
    dict: {
      wizReplaceData: "orgNodeCategoryTree",
      defalutType: []
    },
    formItem: {
      type: 'treeselect',
      rules: [{
        required: true,
        message: '请选择组织类型',
      }],
      allowClear: true
    },
    searchItem: {
      type: 'treeselect',
      allowClear: true
    }
  },
  {
    title: "组织类型",
    name: "organizationNodeCategoryName",
    dataIndex: "organizationNodeCategoryName",
    tableItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "有效" },
      { code: 0, codeName: "无效" }
    ],
    searchItem: {
      type: "select"
      // mode: 'multiple',
    },
    formItem: {

      type: 'Radio',
      rules: [{
        required: true,
        message: '请选择类型',
      }],
      initialValue: 1
    }
  }
];

const templateConfig = ({_btnFun}) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add', 'delete', 'exportOrg', 'importOrg'],
          buttons: [
            {
              key: 'exportOrg',
              custom: true,
              params: { icon: 'export', children: '导出组织', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'importOrg',
              custom: true,
              params: { icon: 'import', children: '导入组织', type: 'import' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/organization/fileImport',
                }
              },
            }
          ]
        },
        siderBarProps: {
          key: "orgNodeTree",
          searchKey: "parentId",
          params: {}
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },

        rowOperateSort: ['look', 'update', 'enableOrDisable', 'authorityManagement'],
        rowOperateView: [
          {
            key: 'look',
            name: 'WizButton',
            params: {
              children: '查看',
              key: 'look',
            },
            onClick: (e) => _btnFun && _btnFun(e)
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "启用" },
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '禁用', 0: '启用' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                  }该组织机构吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 1 ? 0 : 1,
                      ids: [record['id']],
                      //...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "authorityManagement",
            custom: true,
            params: { children: "权限管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/org/organization/orgAuthorityManagement"
              }
            }
          }
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
  treeData: {
    path: `${componentName}/getNodeTreeData`,
    payload: {
      key: `${componentName}@treeData`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/addOrganization`,
    payload: {
      key: `${componentName}@addOrganization`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/updateOrganization`,
    payload: {
      key: `${componentName}@updateOrganization`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/deleteOrganization`,
    payload: {
      key: `${componentName}@deleteOrganization`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enableOrganization`,
    payload: {
      key: `${componentName}@enableOrganization`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'orgNodeCategoryTree', 'treeData'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
